import { cx } from '../lib/cx';
import type { HabitCell } from '../lib/habits';

export interface HabitGridProps {
  cells: readonly HabitCell[];
  ariaLabel: string;
  /** Intenzitet 0–3; jedan ton (accent), svjetlije → tamnije. */
  intensityOf: (cell: HabitCell) => 0 | 1 | 2 | 3;
  titleOf: (cell: HabitCell) => string;
  className?: string;
}

/**
 * Sekvencijalna skala u JEDNOM tonu — nikad duga, nikad status boje.
 * Nula je prazan okvir, ne siva ispuna: prazan dan mora izgledati kao rupa.
 */
const LEVEL: Record<0 | 1 | 2 | 3, string> = {
  0: 'bg-bg-alt',
  1: 'bg-accent/30',
  2: 'bg-accent/60',
  3: 'bg-accent',
};

export function HabitGrid({ cells, ariaLabel, intensityOf, titleOf, className }: HabitGridProps) {
  return (
    <ul
      aria-label={ariaLabel}
      data-testid="habit-grid"
      className={cx('grid grid-flow-col grid-rows-5 gap-1 sm:grid-rows-4', className)}
    >
      {cells.map((cell) => {
        const level = intensityOf(cell);
        return (
          <li key={cell.day}>
            {/* 2 px razmaka radi mreža (`gap-1`), ne obrub — obrub bi dodao tintu koja nije podatak. */}
            <span
              title={titleOf(cell)}
              aria-label={titleOf(cell)}
              data-level={level}
              className={cx('block h-4 w-4 rounded-[4px]', LEVEL[level])}
            />
          </li>
        );
      })}
    </ul>
  );
}
